import { render } from "./spinner.vue?vue&type=template&id=3a9e9895&scoped=true"
const script = {}

import "./spinner.scss?vue&type=style&index=0&id=3a9e9895&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9e9895"]])

export default __exports__